import { ApiBaseFront } from '../api-base-front';
import {Env} from "../../../models/env";
import {APP_CODE} from "../../../containers/initialize";

export type TokenPostRequest = {
  kijshopCd: string,
  password: string,
};

export type TokenPostResponse = {
  kijshopCd: string,
  shopName: string,
  sessionId: string,
  token: string,
  userName: string,
  isAdmin: boolean,
  isLaboUser: boolean,
  needRecaptchaV2: boolean,
  tmpRecaptchaToken: string,
}

export type TokenPostForStaffRequest = {
  kijshopCd: string,
  staffId: string,
  password: string,
}

export type TokenPostForStaffResponse = {
  kijshopCd: string,
  shopName: string,
  sessionId: string,
  token: string,
  staffId: string,
  userName: string,
  roleType: boolean, // 0:店舗, 1:スタッフ
  status: boolean, // 0:仮会員, 1:本会員
  id: string,
  authority: number,
  authorityName: string,
  isAdmin: boolean
  needRecaptchaV2: boolean,
  tmpRecaptchaToken: string,
}

export class ApiTokenPost extends ApiBaseFront<TokenPostResponse> {
  constructor(param: TokenPostRequest) {
    super(
      'POST',
      '/api/v1/token',
      'JSON',
      { ...param, appCode: APP_CODE },
    );
  }
}

export class ApiTokenDelete extends ApiBaseFront {
  constructor(param: { kijshopCd: string }) {
    super(
      'DELETE',
      '/api/v1/token',
      'JSON',
      param,
    );
  }
}

// スタッフログイン
export class ApiTokenPostForStaff extends ApiBaseFront<TokenPostForStaffResponse> {
  constructor(param: TokenPostForStaffRequest) {
    super(
      'POST',
      '/api/v1/token/staff',
      'JSON',
      { ...param, appCode: APP_CODE },
    );
  }
}
